import scanlineMapUtils from '../../../mapUtils';

const isDefined = v => v !== null && v !== undefined;
export const computeRemediationGroups = (
	survey,
	readings,
	depolReadings,
	bcSeriesDs,
	criterionInfo,
	bcReadingById,
	computedBcMap,
	customExceptionsMap
) => {
	// eslint-disable-next-line no-unused-vars
	const { withDepol } = survey;

	const exceptions = scanlineMapUtils.getExceptionsInfo(
		readings,
		depolReadings,
		criterionInfo,
		bcSeriesDs,
		bcReadingById,
		computedBcMap,
		customExceptionsMap
	);

	const groupsRanges = !exceptions
		? []
		: exceptions.list
				.map(group => [
					{
						id: group.start.id,
						gpsdistance: group.start.gpsdistance,
						uuid: group.start.uuid,
						y: 0.5
					},
					{
						id: group.end.id,
						gpsdistance: group.end.gpsdistance,
						uuid: group.end.uuid,
						y: 0.5
					}
				])
				.filter(g => g[0] && isDefined(g[0].gpsdistance) && g[1] && isDefined(g[1].gpsdistance));

	return groupsRanges;
};

export default { computeRemediationGroups };
